<template>  
  <v-container grid-list-lg class="ma-0 pa-0">
    <v-layout row>
      <v-flex xs12 md4>
        <form @submit.prevent="onsubmit">
        <v-card>                    
          <v-card-text>                  
            <v-layout row>
              <v-flex xs6>
                <v-autocomplete outlined dense
                  v-model="fm.idpro"
                  label="Propinsi"
                  :items="propinsies"
                  item-text="name"
                  item-value="id" 
                  :loading="propinsiLoading"   
                  autocomplete="off"              
                >
                  <template v-slot:item="data">
                    <template>
                      <v-list-item-content>
                        <v-list-item-title v-html="data.item.name"></v-list-item-title>
                      </v-list-item-content>
                    </template>
                  </template>
                </v-autocomplete>                                   
              </v-flex>
              <v-flex xs6>
                <v-autocomplete outlined dense
                  v-model="fm.idkab"
                  label="Kabupaten"
                  :items="kabupatens"
                  item-text="name"
                  item-value="id"
                  :loading="kabupatenLoading"
                  autocomplete="off"
                >
                  <template v-slot:item="data">
                    <template>
                      <v-list-item-content>
                        <v-list-item-title v-html="data.item.name"></v-list-item-title>
                      </v-list-item-content>
                    </template>
                  </template>
                </v-autocomplete>                                   
              </v-flex>
              <v-flex xs6>
                <v-autocomplete outlined dense
                  v-model="fm.idkec"
                  label="Kecamatan"
                  :items="kecamatans"
                  item-text="name"
                  item-value="id"
                  :loading="kecamatanLoading"
                  autocomplete="off"
                >
                  <template v-slot:item="data">
                    <template>
                      <v-list-item-content>
                        <v-list-item-title v-html="data.item.name"></v-list-item-title>
                      </v-list-item-content>
                    </template>
                  </template>
                </v-autocomplete>                                   
              </v-flex>
              <v-flex xs6>
                <v-autocomplete outlined dense
                  v-model="fm.idkel"
                  label="Kelurahan"
                  :items="kelurahans"
                  item-text="name"
                  item-value="id"
                  :loading="kelurahanLoading"
                  autocomplete="off"
                >
                  <template v-slot:item="data">
                    <template>
                      <v-list-item-content>
                        <v-list-item-title v-html="data.item.name"></v-list-item-title>
                      </v-list-item-content>
                    </template>
                  </template>
                </v-autocomplete>                                   
              </v-flex>
            </v-layout>


            <v-text-field outlined dense
              label="Nomor"
              v-model="fm.no"
              append-icon="code"
              type="number"
              :error="!!error.no.length"
              :error-messages="error.no"
              style="max-width:200px"
            ></v-text-field>            

            <v-text-field outlined dense
              label="Name"
              v-model="fm.name"
              append-icon="room"
              type="text"
              :error="!!error.name.length"
              :error-messages="error.name"
            ></v-text-field>

            <v-text-field outlined dense
              label="Alamat"
              v-model="fm.alamat"
              append-icon="home"
              type="text"
              :error="!!error.alamat.length"
              :error-messages="error.alamat"
            ></v-text-field>

            <v-layout row>
              <v-flex xs6>
                <v-text-field outlined dense
                  label="PT L"
                  v-model="fm.pt_l"
                  append-icon="person"
                  type="number"
                  :error="!!error.pt_l.length"
                  :error-messages="error.pt_l"                  
                ></v-text-field> 
              </v-flex>
              <v-flex xs6>
                <v-text-field outlined dense
                  label="PT P"
                  v-model="fm.pt_p"
                  append-icon="person"
                  type="number"
                  :error="!!error.pt_p.length"
                  :error-messages="error.pt_p"                  
                ></v-text-field> 
              </v-flex> 
            </v-layout>                        
                      
          </v-card-text>
          <v-card-actions class="pa-4">
            <v-spacer />
            <v-btn type="submit" :color="isUpdate?'blue':'green'" :loading="loading" dark>{{isUpdate?'update':'create'}}</v-btn>
          </v-card-actions>
        </v-card>
        </form>   
      </v-flex>            
    </v-layout>
  </v-container>    
</template>

<script>
import { debounce } from 'lodash'
import model from '@/app/models/master/Tps'

export default {
  data : () => ({  
    fm:{idpro:null,idkab:null,idkec:null,idkel:null,no: null, name: null, alamat:null, pt_l:null,pt_p:null ,parent_id:null, kodepos:null},
    error:{idpro:[],idkab:[],idkec:[],idkel:[],no: [], name : [], alamat:[],  pt_l:[], pt_p:[], parent_id : [], kodepos:[]},
    loading: false,
    isUpdate: false,    
    mode: 0,        
    parents: [],
    propinsies:[], propinsiLoading :false,
    kabupatens:[], kabupatenLoading:false,    
    kelurahans:[], kecamatanLoading:false,
    kecamatans:[], kelurahanLoading:false,
  }),
  computed:{
    levels(){
      let obj = this.$store.getters.DICTIONS.RegionLevel;
      return Object.keys(obj).map(function(key) { return {id:parseInt(key), name: obj[key]}; });
    }
  },
  watch:{
    'fm.idpro'(newId, oldId){
      this.kabupatenLoading = true;
      model.nodes({level:2, parent_id:newId}).then(res=>{
        this.kabupatens = res.data;
        this.kabupatenLoading = false;
      });  
    },
    'fm.idkab'(newId, oldId){
      this.kecamatanLoading = true;
      model.nodes({level:3, parent_id:newId}).then(res=>{
        this.kecamatans = res.data;
        this.kecamatanLoading = false;
      });  
    },
    'fm.idkec'(newId, oldId){
      this.kelurahanLoading = true;
      model.nodes({level:4, parent_id:newId}).then(res=>{
        this.kelurahans = res.data;
        this.kelurahanLoading = false;
      });  
    }
  }, 
  mounted(){
    this.propinsiLoading = true;
    model.nodes({level:1}).then(res=>{
      this.propinsies = res.data;
      this.propinsiLoading = false;
    });

    if(this.$route.query.id){
      this.isUpdate = true;
      model.view({id:this.$route.query.id}).then(data=>{                
        Object.assign(this.fm, data);
      })
    }
  },
  methods: {
    search: debounce(function (e) {      
      this.readParents(e.target.value)
    }, 800),

    readParents(term){
      model.all({q:term}).then(res=>{
        this.parents = res.data;
      })
    },

    onsubmit(){
      this.loading = true;  this.clearErrors();
      if(this.isUpdate){        
        model.update(this.fm, {id:this.fm.id}).then(res=>{this.responseSubmit(res)})
      } else {        
        model.create(this.fm).then(res=>{this.responseSubmit(res)})
      }
    },

    responseSubmit(res){
      this.loading = false;
      if(res.status === 200){
        window.getApp.$emit('showSnackbar', {text :'Data has been saved successfully', color: 'green', show:true});            
        this.$router.replace({name:'master/nodes'})                
      } else {
        this.validate(res.data);
      }
    },

    validate(data){      
      for(var i in data){        
        if(Array.isArray(this.error[data[i]['field']])){          
          this.error[data[i]['field']].push(data[i]['message']);
        }        
      }
    },

    clearErrors(){
      this.error.name    = [];
      this.error.type    = [];
      this.error.address = [];
      this.error.email   = [];
      this.error.node_id = [];      
    }
  },
}
</script>

<style>
.ramping td, .ramping th {
    padding: 0 5px;
}
</style>